import { render } from "./InlineDescriptor.vue?vue&type=template&id=4a7a7764&ts=true"
import script from "./InlineDescriptor.vue?vue&type=script&lang=ts"
export * from "./InlineDescriptor.vue?vue&type=script&lang=ts"

import "./InlineDescriptor.vue?vue&type=style&index=0&id=4a7a7764&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__